module.exports = __webpack_public_path__ + "static/media/email.ac74b747.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/email.png
// module id = 1170
// module chunks = 0